<template>
  <div class="focused-panel">
    <div class="d-flex access-track-toolbar">
      <!--<div class="p-2">{{wellFeature ? wellFeature.get('ident') : 'No well selected'}}</div>-->
      <b-btn class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Create Line" :pressed.sync="addEnabled" variant="primary">
        <icon scale=".6" name="plus"/>
      </b-btn>

      <b-btn class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Select Line" :pressed.sync="selectEnabled" variant="primary">
        <icon scale=".6" name="hand-pointer"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Multi Select" :pressed.sync="multiEdit" variant="primary">
        <icon scale=".6" name="dice-two" />
      </b-btn>

      <b-btn class="dtron-toolbar-button tool1" :id="'undo-'+editorIdent" :disabled="!historyChanges" @click="undo" variant="primary">
        <icon scale=".6" name="undo"/>
      </b-btn>
      <b-tooltip v-if="historyChanges" :target="'undo-'+editorIdent" placement="top">
        Undo
      </b-tooltip>


      <b-btn class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit Line geometry" :disabled="!wellFeatureSelected" :pressed.sync="dragEnabled"
             variant="primary">
        <icon scale=".6" name="arrows-alt"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" variant="primary" :disabled="!mergeEnabled" v-b-tooltip.hover.auto title="Merge 2 lines" @click="mergeLines">
        <icon scale=".6" name="compress" />
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" variant="primary" @click="reverseSelected" :disabled="!wellFeatureSelected" v-b-tooltip.hover.auto title="Reverse">
        <icon scale=".6" name="exchange-alt" />
      </b-btn>


      <b-btn class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit Line attributes" :disabled="!wellFeatureSelected" :pressed.sync="editEnabled"
             variant="primary">
        <icon scale=".6" name="pencil-alt"/>
      </b-btn>

      <b-btn class="dtron-toolbar-button tool1" @click="deleteFetaures" v-b-tooltip.hover.auto title="Delete lines" :disabled="!wellFeatureSelected"
             variant="primary">
        <icon scale=".6" name="times"/>
      </b-btn>

      <b-btn class="dtron-toolbar-button tool1" :pressed.sync="ldEnabled" v-b-tooltip.hover.auto title="Load dependant layers"
             variant="primary">
        <icon scale=".6" name="link"/>
      </b-btn>

    </div>

    <b-modal v-model="showForm" no-close-on-backdrop no-close-on-esc>
      <div slot="modal-header">
        <label>{{formTitle}}</label>

      </div>
      <div class="p-2">


        <b-form>
          <b-form-group label="Name:" label-for="track-asset-tag">
            <b-form-input :disabled="featureLock" id="track-asset-tag" v-model="wellAttrs['name']" placeholder="Enter Name"></b-form-input>
          </b-form-group>

          <b-form-group label="Description:" label-for="accessComment">
            <b-textarea id="accessComment" :disabled="featureLock" v-model="wellAttrs['description']" rows="3"></b-textarea>
          </b-form-group>

        </b-form>
      </div>
      <div slot="modal-footer" class="designatron-modal-footer">
        <b-row>
          <!-- <b-col>
            <div id="update-survey-container">
              <b-btn size="sm" @click="surveyUpdate">
                Update from survey
              </b-btn>
            </div>
          </b-col> -->
          <b-col>
            <div role="group" class="btn-group">
              <b-btn size="sm" class="float-right" variant="primary" @click="close">
                Close
              </b-btn>
              <b-btn size="sm" :disabled="featureLock" class="float-right" variant="success" @click="onOK">
                Save
              </b-btn>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-modal>


  </div>
</template>

<script>


  import FeatureEditorMixin from '../../../mixins/FeatureEditorMixin'
  import Draw from 'ol/interaction/Draw'
  import Snap from 'ol/interaction/Snap'
  import bezierCurve from '@turf/bezier-spline'
  import GeoJSON from 'ol/format/GeoJSON'
  import { LineString } from 'ol/geom'

  export default {
    name: 'tracklog-line-editor',
    components: {},
    mixins: [FeatureEditorMixin],
    data () {
      return {
        multiEdit: false,
        mergeEnabled: false,
        ratEnabled: false,
        geomType: 'LineString',
        wellLayerName: 'v4:tracklog_linestring',
        wellAttrs: {
          name: '',
          description: ''
        },
        schema: 'tracklog_linestring',
        track_type: 0,
        tracks_types: [],
        ratPoints: [],
        identState: null,
        initialIdent: null,
        hoverLock: false,
        lockable: true
      }
    },
    methods: {
      reverseSelected() {
        let lines = this.selectInteraction.getFeatures().getArray()
        lines.forEach(line => {
          line.getGeometry().setCoordinates(line.getGeometry().getCoordinates().reverse())
        })
        this._edit(lines)
        this.selectInteraction.getFeatures().clear()
      },
      loadTypeLibrary() {
        this.$http.get('/api/layers/access-track-type').then(res => {
          let fil = res.body.filter(f => f.subject)
          this.tracks_types = fil.map(m => {
            return {
              text: m.subject,
              value: m.id
            }
          })
          this.tracks_types = this.tracks_types.concat({
            text: 'None',
            value: 0
          })
          if (this.wellFeature.get('library_id')) {
            this.track_type = JSON.parse(this.wellFeature.get('library_id'))
          } else {
            this.track_type = 0
          }
        }, res => {
          console.log('Error Thrown')
          console.log(res)
        })
      },
      close(evt) {
        this.wellFeature = null
        this.showForm = false
        this.onCancel()
      },
      surveyUpdate() {
        this.updateFeatureFromSurvey()
        this.close()
      }
    },
    watch: {
      ratPoints (val) {
        if (val.length === 3) {

          let points = this.ratPoints.map(f => f.getGeometry().getCoordinates())
          this.drawRatCurve(points)
          this.servicingLayer.getSource().clear();

          this.ratPoints.splice(0, this.ratPoints.length)
        }
      },
      ratEnabled (val) {
        if (val) {
          this.initRat()
        } else {
          this.deinitRat()
        }
      },
      countSelectedFeatures(val) {
        this.mergeEnabled = val === 2
      },
      showForm(val) {
        if (this.tracks_types.length == 0) {
          this.loadTypeLibrary()
        } else {
          if (this.wellFeature.get('library_id')) {
            this.track_type = JSON.parse(this.wellFeature.get('library_id'))
          } else {
            this.track_type = 0
          }
        }
      },
      wellAttrs: {
        handler(val) {
          if (!this.initialIdent) {
            this.initialIdent = val.ident
          }
          else if (this.initialIdent !== val.ident) {
            let me = this
            this.validateIdent(val.ident)
          } else {
            this.identState = null
          }
        },
        deep: true
      },
      track_type(val) {
        if (val) {
          this.wellAttrs['library_id'] = val
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/map/designotron/TracklogLineEditor.vue